import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import updateTrigger from 'API/Triggers/updateTrigger';
import { toast } from 'react-toastify';

const useUpdateTrigger = (data, isEditMode, resetToMainTable) => {
    const { currentScope } = useSelector((state) => state.login);
    return useMutation({
        mutationFn: async () => {
            try {
                updateTrigger({
                    updatedTrigger: data,
                    currentScope: currentScope,
                }).then((res) => {
                    toast.success('Trigger Update Success!');
                    resetToMainTable();
                    return res;
                });
            } catch (error) {
                const errorMessage = `Failed to update trigger: ${error?.response?.data?.message}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
        enabled: !!data && isEditMode,
    });
};

export default useUpdateTrigger;
